(function () {
  'use strict';

  function formatMoney(cents) {
    if (cents === null || cents === undefined) return '';
    cents = parseInt(cents, 10);
  
    const currency =
      window.Shopify?.currency?.active ||
      document.querySelector('[data-currency-code]')?.dataset.currencyCode ||
      document.querySelector('[data-shopify-currency]')?.dataset.shopifyCurrency ||
      document.querySelector('meta[name="currency"]')?.content ||
      'INR';
  
    const amount = cents / 100;
  
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'symbol'
      }).format(amount);
    } catch (e) {
      return currency + ' ' + amount.toFixed(2);
    }
  }

  class StickyCart {
    constructor(sectionId) {
      this.sectionId      = sectionId;
      this.bar            = document.getElementById('sticky-cart-' + sectionId);
      if (!this.bar) return;

      this.btn            = this.bar.querySelector('.sticky-cart__btn');
      this.imgEl          = this.bar.querySelector('.sticky-cart__image img');
      this.priceEl        = this.bar.querySelector('.sticky-cart__price');
      this.variantEl      = this.bar.querySelector('.sticky-cart__variant');
      this.variantSelects = this.bar.querySelectorAll('.sticky-cart__variant-select');

     this.mainForm = document.getElementById('product-form-' + sectionId)
  || document.querySelector('form[action*="/cart/add"]');

      this._setupScrollObserver();
      this._setupVariantSync();
      this._setupAddToCart();
    }

 _setupScrollObserver() {
  const trigger = document.querySelector('.button--form')
    || document.querySelector(
      '.product__media-wrapper, .product-media-wrapper, .product__media, [data-product-media], .product-single__photo, .product__photo, .product__info-wrapper, .product-form'
    )
    || this.mainForm
    || document.querySelector('.product-form, [data-type="add-to-cart-form"]');

  if (!trigger) return;

  let passedTrigger = false;
  let footerVisible = false;

  const updateBarVisibility = () => {
    const show = passedTrigger && !footerVisible;
    this.bar.classList.toggle('is-visible', show);
    this.bar.setAttribute('aria-hidden', String(!show));
  };

  new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) {

        if (entry.boundingClientRect.bottom < 0) {
          passedTrigger = true;
        }
      } else {
        passedTrigger = false;
      }
      updateBarVisibility();
    },
    { threshold: 0, rootMargin: '0px 0px 0px 0px' }
  ).observe(trigger);

  const footer = document.querySelector('footer, .footer, #shopify-section-footer');
  if (footer) {
    new IntersectionObserver(
      ([entry]) => {
        footerVisible = entry.isIntersecting;
        updateBarVisibility();
      },
      { threshold: 0 }
    ).observe(footer);
  }
}

    _setupVariantSync() {
      document.addEventListener('sticky:variant:change', (e) => {
        this._updateBar(e.detail.variant);
      });

      const variantInput = this.mainForm?.querySelector('input[name="id"]');
      if (variantInput) {
        new MutationObserver(() => this._syncFromId(variantInput.value))
          .observe(variantInput, { attributes: true, attributeFilter: ['value'] });
        variantInput.addEventListener('change', () => this._syncFromId(variantInput.value));
      }

      this.variantSelects.forEach((sel, idx) => {
        sel.addEventListener('change', () => {
          if (!this.mainForm) return;
          const mainSel = this.mainForm.querySelectorAll('select[name^="options"]')[idx];
          if (mainSel) {
            mainSel.value = sel.value;
            mainSel.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
          const radio = this.mainForm.querySelector(
            `input[type="radio"][value="${CSS.escape(sel.value)}"]`
          );
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }

    _syncFromId(variantId) {
      if (!variantId) return;
      const all     = window._fullVariantCache || this._productData()?.variants || [];
      const variant = all.find(v => String(v.id) === String(variantId));
      if (variant) this._updateBar(variant);
    }

    _updateBar(variant) {
      if (!variant) return;

      if (this.priceEl) this.priceEl.textContent = formatMoney(variant.price);

      if (this.variantEl) {
        const opts = (variant.options || []).filter(o => o !== 'Default Title');
        this.variantEl.textContent = opts.join(' / ');
      }

      if (this.imgEl) {
        const img = variant.featured_image || variant.featuredImage;
        if (img) {
          const src = typeof img === 'string' ? img : img.src;
          if (src) this.imgEl.src = src;
        }
      }

      if (this.btn) {
        this.btn.disabled = variant.available === false;
      }

      this.variantSelects.forEach((sel, i) => {
        if (variant.options?.[i] !== undefined) sel.value = variant.options[i];
      });

      this.bar.dataset.currentVariantId = variant.id;
    }

    _productData() {
      try {
        const el = document.querySelector('[data-product-json]');
        return el ? JSON.parse(el.textContent) : null;
      } catch { return null; }
    }

    _setupAddToCart() {
      if (!this.btn) return;

      this.btn.addEventListener('click', async (e) => {
        e.preventDefault();

        const realSubmit = this.mainForm?.querySelector(
          'button[name="add"], button[type="submit"], .product-form__submit'
        );

        if (realSubmit && !realSubmit.disabled) {
          realSubmit.click();
          return;
        }

        const variantId = this.bar.dataset.currentVariantId
          || this.mainForm?.querySelector('input[name="id"]')?.value;
        if (!variantId) return;

        const qty = parseInt(this.mainForm?.querySelector('[name="quantity"]')?.value || 1, 10);

        try {
          const res = await fetch('/cart/add.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body:    JSON.stringify({ id: Number(variantId), quantity: qty }),
          });
          if (!res.ok) throw new Error('HTTP ' + res.status);

          fetch('/cart.js').then(r => r.json()).then(cart => {
            document.querySelectorAll(
              '[data-cart-count],.cart-count,.cart__count,.header__cart-count'
            ).forEach(el => { el.textContent = cart.item_count; });
          });

          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:refresh',  { bubbles: true }));

          const drawer = document.querySelector('cart-drawer');
          if (drawer) {
            if (typeof drawer.open === 'function') drawer.open();
            else drawer.setAttribute('open', '');
          }

        } catch (err) {
          console.error('[StickyCart] ATC error:', err);
        }
      });
    }
  }

  function init() {
    const done = new Set();
    document.querySelectorAll('[data-sticky-cart-section]').forEach(el => {
      const id = el.dataset.stickyCartSection;
      if (id && !done.has(id)) { new StickyCart(id); done.add(id); }
    });
    (window.__stickySectionIds || []).forEach(id => {
      if (!done.has(id)) { new StickyCart(id); done.add(id); }
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();